<div class="home_background">
  <div *ngFor="let module of myModules" class="flex_item">
    <a [routerLink]="[module.route]" class="sector_card">
      <!-- <span *ngIf="module.name === 'CRM'" class="notice"> 12</span> -->
      <img alt="" src="{{module.icon}}">
      <h4>{{ module.name | translate}}</h4>
    </a>
  </div>
</div>
